import { useRefreshStatusPolling } from './useRefreshStatusPolling';
import { useInitRefresh } from './useInitRefresh';
import { useCancelRefresh } from './useCancelRefresh';
export var useRefresh = function (_a) {
    var listId = _a.listId, inProgressRefresh = _a.inProgressRefresh, onErrorPolling = _a.onErrorPolling, onSuccessPolling = _a.onSuccessPolling, onError = _a.onError, _b = _a.onCancelRefresh, onCancelRefresh = _b === void 0 ? function () { } : _b, _c = _a.onCancelError, onCancelError = _c === void 0 ? function () { } : _c, _d = _a.onCancelSuccess, onCancelSuccess = _d === void 0 ? function () { } : _d;
    var _e = useRefreshStatusPolling({
        listId: listId,
        inProgressRefresh: inProgressRefresh,
        onErrorPolling: onErrorPolling,
        onSuccessPolling: onSuccessPolling,
        onCancelRefresh: onCancelRefresh,
        onError: onError
    }), stopPolling = _e.stopPolling, startPolling = _e.startPolling, isPollingInProgress = _e.isPollingInProgress, polledData = _e.polledData, poolStatus = _e.poolStatus;
    var initRefresh = useInitRefresh({
        onSuccess: function (data) {
            startPolling(data.id);
        },
        onError: onError
    }).initRefresh;
    var _f = useCancelRefresh({
        listId: listId,
        onSuccess: function () {
            onCancelSuccess();
            stopPolling();
        },
        onError: function (error) {
            onCancelError(error);
            poolStatus();
        }
    }), cancelRefresh = _f.cancelRefresh, cancelInProgress = _f.cancelInProgress;
    return {
        initRefresh: function () {
            initRefresh(listId);
        },
        isRefreshInProgress: isPollingInProgress,
        cancelRefresh: cancelRefresh,
        isCancelRefreshInProgress: cancelInProgress,
        polledData: polledData,
    };
};
